(function () {
  var TAG = "[ContactUs]";
  console.log(TAG, "asset loaded");

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    var attempts = 0;
    var max = 100;

    function attach() {
      attempts++;
      var heading = document.getElementById("contact-heading");
      var list = document.getElementById("contact-list");

      if (!heading || !list) {
        if (attempts >= max) {
          console.error(TAG, "GAVE UP - elements never appeared");
          return;
        }
        setTimeout(attach, 200);
        return;
      }

      if (heading.dataset.bound === "true") {
        return;
      }
      heading.dataset.bound = "true";
      console.log(TAG, "bound");

      heading.addEventListener("click", function (e) {
        console.log(TAG, "click");
        e.preventDefault();
        e.stopPropagation();
        var isOpen = list.style.display === "block";
        list.style.display = isOpen ? "none" : "block";
        if (isOpen) {
          heading.classList.remove("open");
        } else {
          heading.classList.add("open");
        }
        heading.setAttribute("aria-expanded", String(!isOpen));
      });
    }

    attach();
  });
})();